import { Component, Input, OnInit, SecurityContext } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-video-tutorial-modal',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  templateUrl: './video-tutorial-modal.component.html',
  styleUrl: './video-tutorial-modal.component.scss'
})
export class VideoTutorialModalComponent implements OnInit {
  @Input() videoUrl: string = '';
  @Input() title: string = 'Tutoriel vidéo';
  
  visible: boolean = false;
  safeVideoUrl!: SafeResourceUrl;
  
  constructor(private sanitizer: DomSanitizer) {}
  
  ngOnInit(): void {
    // Préparer l'URL pour l'iframe
    this.processVideoUrl();
  }

  processVideoUrl(): void {
    // Convertir une URL YouTube standard en URL d'intégration
    if (this.videoUrl) {
      let embedUrl = this.videoUrl;
      
      // Gérer les formats d'URL YouTube standards
      const youtubeRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
      const match = this.videoUrl.match(youtubeRegex);
      
      if (match && match[1]) {
        // Extraire l'ID de la vidéo et créer l'URL d'intégration
        const videoId = match[1];
        embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
      }
      
      // Sanitize l'URL pour une utilisation sécurisée dans un iframe
      this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
    }
  }
  
  openModal(): void {
    this.visible = true;
  }
  
  closeModal(): void {
    this.visible = false;
    localStorage.setItem('videoTutorialSeen', 'true');
  }
}